// extracted by mini-css-extract-plugin
export var smallSpinner = "_s4-0";